// Estilo compacto y de esquinas rectas para los formularios del módulo Egresos.
// El tema global le pone margen a los FormControl (margin "dense"/"normal"): aquí se anula (m: 0) para que
// las filas queden pegadas, y la etiqueta se reposiciona para campos de 28 px de alto.
export const fieldSx = {
  m: 0,
  "& .MuiOutlinedInput-root": { borderRadius: 0, minHeight: 28, bgcolor: "background.paper" },
  "& .MuiInputBase-input": { py: "3px", px: "8px", fontSize: "0.78rem" },
  "& .MuiAutocomplete-inputRoot": { py: "0 !important" },
  "& .MuiAutocomplete-input": { py: "1px !important" },
  "& .MuiInputLabel-root": {
    fontSize: "0.76rem",
    transform: "translate(9px, 5px) scale(1)",
    "&.MuiInputLabel-shrink": { transform: "translate(10px, -8px) scale(0.85)" },
  },
  "& .MuiSelect-select": { minHeight: "unset !important" },
};
